import React from 'react';
import { Calendar, Ticket, CheckCircle2 } from 'lucide-react';

const ReservationStatsCards = ({ activeReservations = 0, totalReservations = 0 }) => {
  const cards = [
    {
      label: 'Active Reservation',
      value: activeReservations,
      subtext: 'Pending & confirmed reservations',
      icon: Calendar,
      color: 'teal',
      showPing: activeReservations > 0
    },
    {
      label: 'Total Reservations',
      value: totalReservations,
      subtext: 'All-time guest bookings',
      icon: Ticket,
      color: 'indigo',
      showPing: false
    }
  ];

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-6 mb-8">
      {cards.map((card, idx) => {
        const Icon = card.icon;
        return (
          <div
            key={idx}
            className="bg-white p-6 rounded-3xl shadow-sm border border-slate-100 flex flex-col justify-between hover:shadow-md transition-all duration-300 group relative overflow-hidden"
          >
            <div className="flex justify-between items-start mb-4 relative z-10">
              <div className={`relative w-12 h-12 rounded-2xl flex items-center justify-center transition-colors duration-300 ${
                card.color === 'teal'
                  ? 'bg-teal-50 text-[#067978] group-hover:bg-[#067978] group-hover:text-white'
                  : 'bg-indigo-50 text-indigo-600 group-hover:bg-indigo-600 group-hover:text-white'
              }`}>
                <Icon size={22} />
                {card.showPing && (
                  <span className="absolute top-1.5 right-1.5 w-3 h-3 bg-red-500 border-2 border-white rounded-full animate-ping"></span>
                )}
              </div>

              <span className={`text-[10px] font-extrabold uppercase tracking-widest px-3 py-1 rounded-full border ${
                card.color === 'teal'
                  ? 'bg-teal-50 text-[#067978] border-teal-100'
                  : 'bg-indigo-50 text-indigo-600 border-indigo-100'
              }`}>
                Live Metric
              </span>
            </div>

            <div className="relative z-10">
              <h3 className="text-slate-400 text-xs font-black uppercase tracking-wider mb-1">
                {card.label}
              </h3>
              <p className="text-3xl sm:text-4xl font-extrabold text-slate-800 leading-none">
                {card.value.toLocaleString()}
              </p>
              <p className={`text-[11px] font-bold mt-2 flex items-center gap-1 ${
                card.color === 'teal' ? 'text-[#067978]' : 'text-indigo-600'
              }`}>
                <CheckCircle2 size={12} />
                {card.subtext}
              </p>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default ReservationStatsCards;
